<template>
  <div class="flex-grow grid grid-cols-1 md:grid-cols-3 mx-auto gap-16">
    <div class="flex flex-row justify-center">
      <img class="rounded-3xl" src="@/assets/images/home.webp" />
      <br>
    </div>
    <div class="w-[300px] rounded-3xl p-4 bg-beige-x">
      <h2 class="text-red-x">Charte?</h2>
      <p>Die <span class="text-red-x">«DigiCharte»</span> geht <strong>per Post an neu gegründete und neu zugezogene Firmen</strong>. Die Karten werden mehrmals in Folge versendet und enthalten verschiedene <strong>Inserate</strong> mit tollen Angeboten aus der Umgebung.</p>
    </div>
    <div class="w-[300px] rounded-3xl p-4 bg-beige-x">
      <h2 class="text-red-x">Digi?</h2>
      <p>Sie legen in Worten fest, an wen Ihr Inserat ausgespielt wird, z.B. an alle Firmen, die «nicht mehr als 5 km entfernt sind». Ihr Inserat wird fortlaufend (so lange Ihre Kampagne läuft) individuell bei den passenden Empfängern auf die <span class="text-red-x">«DigiCharte»</span> gedruckt.</p>
    </div>

    <div class="w-[300px] rounded-3xl p-4 bg-beige-x">
      <h2 class="text-red-x">Warum?</h2>
      <p>Mit der «DigiCharte» erreichen Sie fortlaufend neu gegründete und neu zugezogene Firmen in Ihrer Umgebung günstig und ohne Aufwand!</p>
      <p>Sie machen den perfekten ersten Eindruck und gewinnen neue Kunden, die Ihnen langjährig treu sein werden.</p>
    </div>
    <div class="w-[300px] rounded-3xl p-4 bg-yellow-x">
      <h2 class="text-red-x">Wie funktioniert's?</h2>
      <p>Rufen Sie an, um mehr zu erfahren und am Pilotprojekt der innovativen «DigiCharte» teilzunehmen!</p>
      <p>&nbsp;</p>
      <p class="bg-orange-x p-2 text-center"><a class="text-black hover:text-white font-bold text-xl" href="tel:+41325101385">032 510 13 85</a></p>
      <p class="bg-orange-x p-2 text-center"><a class="text-black hover:text-white font-bold text-xl" href="mailto:hallo@digicharte.ch">hallo@digicharte.ch</a></p>
    </div>
    <div class="w-[300px] rounded-3xl p-4 bg-beige-x">
      <h2 class="text-red-x">Vorteile?</h2>
      <ul>
        <li>Teures Adressen kaufen entfällt</li>
        <li>Wer eine neue Firma zuerst als Kunde gewinnt hat die Nase vorn, weil sie oft langjährig treuer Kunde bleiben wird</li>
        <li>Neukunden gewinnen mit Autopilot: sobald eine Firma gegründet wird oder zuzieht, die Ihren Kriterien entspricht, wird sie automatisch mit Ihrem Inserat beworben</li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
</script>
